import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import {
    AUTH_TOKEN,
    SIGNIN,
    SIGNOUT,
    SIGNUP,
    SIGNIN_WITH_GOOGLE,
    SIGNIN_WITH_FACEBOOK,
    AUTH_USER,
} from '../constants/Auth';
import {
    showAuthMessage,
    authenticated,
    signOutSuccess,
    signUpSuccess,
    signInWithGoogleAuthenticated,
    signInWithFacebookAuthenticated,
} from '../actions/Auth';

import FirebaseService from 'services/FirebaseService';
import JwtAuthService from 'services/JwtAuthService';
import Utils from 'utils';

export function* signInWithFBEmail() {
    yield takeEvery(SIGNIN, function* ({ payload }) {
        const { email, password } = payload;
        try {
            //const user = yield call(FirebaseService.signInEmailRequest, email, password);
            const response = yield call(JwtAuthService.login, { email, password });
            /* if (user.message) {
                yield put(showAuthMessage(user.message));
            } else {*/
            if (Utils.isAdministrator(response.data.user) || Utils.isOwner(response.data.user)) {
                localStorage.setItem(AUTH_TOKEN, response.data.tokens.accessToken);
                localStorage.setItem(AUTH_USER, JSON.stringify(response.data.user));
                yield put(authenticated(response.data.tokens.accessToken, response.data.user));
            } else {
                yield put(showAuthMessage("Non è consentito l'accesso a questo tipo di utente"));
            }

            //  }
        } catch (err) {
            if (err.response) {
                yield put(showAuthMessage(err.response.data.message));
            } else {
                yield put(showAuthMessage('Error while login in'));
            }
        }
    });
}

export function* signOut() {
    yield takeEvery(SIGNOUT, function* () {
        try {
            //const signOutUser = yield call(FirebaseService.signOutRequest);
            yield call(JwtAuthService.logout);
            //if (signOutUser === undefined) {
            localStorage.removeItem(AUTH_TOKEN);
            yield put(signOutSuccess());
            //} else {
            //    yield put(showAuthMessage(signOutUser.message));
            //}
        } catch (err) {
            localStorage.removeItem(AUTH_TOKEN);
            yield put(signOutSuccess());
            // yield put(showAuthMessage(err));
        }
    });
}

export function* signUpWithFBEmail() {
    yield takeEvery(SIGNUP, function* ({ payload }) {
        const { email, password } = payload;
        try {
            const user = yield call(FirebaseService.signUpEmailRequest, email, password);
            if (user.message) {
                yield put(showAuthMessage(user.message));
            } else {
                localStorage.setItem(AUTH_TOKEN, user.user.uid);
                yield put(signUpSuccess(user.user.uid));
            }
        } catch (error) {
            yield put(showAuthMessage(error));
        }
    });
}

export function* signInWithFBGoogle() {
    yield takeEvery(SIGNIN_WITH_GOOGLE, function* () {
        try {
            const user = yield call(FirebaseService.signInGoogleRequest);
            if (user.message) {
                yield put(showAuthMessage(user.message));
            } else {
                localStorage.setItem(AUTH_TOKEN, user.user.uid);
                yield put(signInWithGoogleAuthenticated(user.user.uid));
            }
        } catch (error) {
            yield put(showAuthMessage(error));
        }
    });
}

export function* signInWithFacebook() {
    yield takeEvery(SIGNIN_WITH_FACEBOOK, function* () {
        try {
            const user = yield call(FirebaseService.signInFacebookRequest);
            if (user.message) {
                yield put(showAuthMessage(user.message));
            } else {
                localStorage.setItem(AUTH_TOKEN, user.user.uid);
                yield put(signInWithFacebookAuthenticated(user.user.uid));
            }
        } catch (error) {
            yield put(showAuthMessage(error));
        }
    });
}

export default function* rootSaga() {
    yield all([
        fork(signInWithFBEmail),
        fork(signOut),
        fork(signUpWithFBEmail),
        fork(signInWithFBGoogle),
        fork(signInWithFacebook),
    ]);
}
